import React, { useState, useMemo, useRef } from "react";
import Navbar from "../components/navbar";
import "../css/email.css";
import ReactQuill from "react-quill-new";
import "quill/dist/quill.snow.css";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";
const EMAIL_TYPES = {
    MEETING: "meeting",
    ANNOUNCEMENT: "announcement",
    IMAGE: "image",
};

const logoUrl =
    "https://soleministries.org/SOLE-logo.png"; // Use a full HTTPS URL so email clients can load it
const unsubscribeUrl = "https://soleministries.org/unsubscribe"; // TODO: replace with your real unsubscribe page

function buildEmailHtml(type, fields) {
    const {
        subject,
        orgLine,
        meetingTitle,
        meetingDateTime,
        location,
        talkDescription,
        optionalMessage,
        announcementBody,
        imageBody,
        imageUrl,
    } = fields;

    let bodyContent = "";

    if (type === EMAIL_TYPES.MEETING) {
        bodyContent = `
      <p style="margin:0 0 12px 0;">
        Hey everyone,
      </p>
      <p style="margin:0 0 12px 0;">
        We’re excited to invite you to our next SOLE meeting:
      </p>
      <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin:0 0 16px 0;border:1px solid #F1B249;border-collapse:collapse;">
        <tr>
          <td style="padding:4px 8px;font-weight:bold;color:#0F3650;">Title:</td>
          <td style="padding:4px 8px;color:#0F3650;">${meetingTitle || ""}</td>
        </tr>
        <tr>
          <td style="padding:4px 8px;font-weight:bold;color:#0F3650;">Date / Time:</td>
          <td style="padding:4px 8px;color:#0F3650;">${meetingDateTime || ""}</td>
        </tr>
        <tr>
          <td style="padding:4px 8px;font-weight:bold;color:#0F3650;">Location:</td>
          <td style="padding:4px 8px;color:#0F3650;">${location || ""}</td>
        </tr>
      </table>
            ${talkDescription
                ? `<div style="margin:0 0 12px 0;">
                   <strong>Talk Description:</strong><br />
                   ${talkDescription}
                 </div>`
                : ""
            }
      ${optionalMessage
                ? `<div style="margin:0 0 12px 0;">
                   ${optionalMessage}
                 </div>`
                : ""
            }
      <p style="margin:0 0 12px 0;">
        We’d love to see you there—bring a friend!
      </p>
    `;
    } else if (type === EMAIL_TYPES.ANNOUNCEMENT) {
        bodyContent = announcementBody || "";
    } else if (type === EMAIL_TYPES.IMAGE) {
        bodyContent = `
      ${imageBody
                ? `<div style="margin:0 0 12px 0;">
                   ${imageBody}
                 </div>`
                : ""
            }
      ${imageUrl
                ? `<div style="margin:16px 0;text-align:center;">
                   <img src="${imageUrl}" alt="" style="max-width:100%;border-radius:6px;" />
                 </div>`
                : ""
            }
    `;
    }

    const safeSubject = subject || "";

    return `
<!DOCTYPE html>
<html>
  <head>
    <meta charset="UTF-8" />
    <meta name="color-scheme" content="light" />
    <meta name="supported-color-schemes" content="light" />
    <title>${safeSubject}</title>
  </head>
  <body style="margin:0;padding:0;background-color:#FBF3E4;">
    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color:#FBF3E4;padding:24px 0;">
      <tr>
        <td align="center">
          <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="max-width:640px;background-color:#FBF3E4;border:1px solid #F1B249;border-radius:12px;overflow:hidden;box-shadow:0 8px 20px rgba(15,23,42,0.12);font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;">
            <!-- Header -->
            <tr>
  <td bgcolor="#0f3650" style="padding:0;background-color:#0f3650;">
    <img
      src="https://soleministries.org/banner.png"
      width="640"
      height="120"
      alt="Servants of Our Lady of Evangelization"
      style="
        display:block;
        width:100%;
        max-width:640px;
        height:auto;
        border:0;
        outline:none;
        text-decoration:none;
      "
    />
  </td>
</tr>

            <!-- Gold seam under the banner -->
            <tr>
              <td height="4" style="height:4px;font-size:1px;line-height:4px;background-color:#F1B249;">&nbsp;</td>
            </tr>

            <!-- Subject (as headline) -->
            ${safeSubject
            ? `
            <tr>
              <td style="padding:20px 24px 8px 24px;border-bottom:1px solid #E6D8BC;">
                <h1 style="margin:0;font-size:22px;line-height:1.3;color:#0f3650;font-weight:650;">
                  ${safeSubject}
                </h1>
              </td>
            </tr>
                `
            : ""
        }

            <!-- Body -->
            <tr>
              <td style="padding:16px 24px 24px 24px;font-size:15px;line-height:1.6;color:#0F3650;">
                ${bodyContent}
              </td>
            </tr>

            <!-- Footer -->
            <tr>
              <td style="padding:16px 24px 20px 24px;font-size:11px;line-height:1.5;color:#6f6553;background-color:#F3E8D0;border-top:1px solid #E6D8BC;">
                <p style="margin:0 0 8px 0;">
                  You are receiving this email from SOLE (Servants of Our Lady of Evangelization).
                </p>
                <p style="margin:0;">
                  If you no longer wish to receive these emails, you can
                  <a href="${unsubscribeUrl}" style="color:#0f3650;text-decoration:underline;">unsubscribe here</a>.
                </p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>
  `.trim();
}

const Email = () => {
    const [emailType, setEmailType] = useState(EMAIL_TYPES.MEETING);
    const [subject, setSubject] = useState("");
    const [orgLine, setOrgLine] = useState("");
    const [meetingTitle, setMeetingTitle] = useState("");
    const [meetingDateTime, setMeetingDateTime] = useState("");
    const [location, setLocation] = useState("");
    const [talkDescription, setTalkDescription] = useState("");
    const [optionalMessage, setOptionalMessage] = useState("");
    const [announcementBody, setAnnouncementBody] = useState("");
    const [imageBody, setImageBody] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [copied, setCopied] = useState(false);
    const [copiedFormatted, setCopiedFormatted] = useState(false);
    const [copiedMailingList, setCopiedMailingList] = useState(false);

    const formattedRef = useRef(null);

    const htmlOutput = useMemo(
        () =>
            buildEmailHtml(emailType, {
                subject,
                orgLine,
                meetingTitle,
                meetingDateTime,
                location,
                talkDescription,
                optionalMessage,
                announcementBody,
                imageBody,
                imageUrl,
            }),
        [
            emailType,
            subject,
            orgLine,
            meetingTitle,
            meetingDateTime,
            location,
            talkDescription,
            optionalMessage,
            announcementBody,
            imageBody,
            imageUrl,
        ]
    );

    const emailInnerHtml = useMemo(() => {
        const match = htmlOutput.match(/<body[^>]*>([\s\S]*)<\/body>/i);
        return match ? match[1].trim() : htmlOutput;
    }, [htmlOutput]);

    const handleCopyHtml = async () => {
        try {
            await navigator.clipboard.writeText(htmlOutput);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error("Failed to copy HTML:", err);
            setCopied(false);
        }
    };

    const handleCopyFormatted = async () => {
        const html = emailInnerHtml;

        // Prefer the async Clipboard API with HTML support when available
        if (navigator.clipboard && window.ClipboardItem) {
            try {
                const htmlBlob = new Blob([html], { type: "text/html" });
                // Basic plain-text fallback (strip tags naively)
                const textBlob = new Blob(
                    [html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim()],
                    { type: "text/plain" }
                );

                const item = new window.ClipboardItem({
                    "text/html": htmlBlob,
                    "text/plain": textBlob,
                });

                await navigator.clipboard.write([item]);
                setCopiedFormatted(true);
                setTimeout(() => setCopiedFormatted(false), 2000);
                return;
            } catch (err) {
                console.error("Failed to copy with ClipboardItem, falling back:", err);
            }
        }

        // Fallback: select from hidden div and use execCommand
        const el = formattedRef.current;
        if (!el) return;
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(el);
        selection.removeAllRanges();
        selection.addRange(range);
        try {
            document.execCommand("copy");
            setCopiedFormatted(true);
            setTimeout(() => setCopiedFormatted(false), 2000);
        } catch (err) {
            console.error("Failed to copy formatted content:", err);
            setCopiedFormatted(false);
        } finally {
            selection.removeAllRanges();
        }
    };

    const handleCopyMailingList = async () => {
        try {
            const snapshot = await getDocs(collection(db, "subscribers"));
            const emails = snapshot.docs
                .map((doc) => {
                    const data = doc.data();
                    const e = (data.email || data.emailRaw || "").toString().trim();
                    return e.toLowerCase();
                })
                .filter((e, idx, arr) => e && arr.indexOf(e) === idx);

            if (!emails.length) {
                console.warn("No subscribers found to copy.");
                setCopiedMailingList(false);
                return;
            }

            const mailingListText = emails.join(", ");
            await navigator.clipboard.writeText(mailingListText);
            setCopiedMailingList(true);
            setTimeout(() => setCopiedMailingList(false), 2000);
        } catch (err) {
            console.error("Failed to copy mailing list:", err);
            setCopiedMailingList(false);
        }
    };

    const renderTypeSpecificFields = () => {
        if (emailType === EMAIL_TYPES.MEETING) {
            return (
                <>
                    <div className="field">
                        <label>Meeting Title</label>
                        <input
                            type="text"
                            value={meetingTitle}
                            onChange={(e) => setMeetingTitle(e.target.value)}
                            placeholder="Why We Need Organized Religion"
                        />
                    </div>
                    <div className="field">
                        <label>Date / Time</label>
                        <input
                            type="text"
                            value={meetingDateTime}
                            onChange={(e) => setMeetingDateTime(e.target.value)}
                            placeholder="Monday, Sept 8 · 6:45–8:00 PM"
                        />
                    </div>
                    <div className="field">
                        <label>Location</label>
                        <input
                            type="text"
                            value={location}
                            onChange={(e) => setLocation(e.target.value)}
                            placeholder="St. Mary's, Activity Center Room 101"
                        />
                    </div>
                    <div className="field">
                        <label>Talk Description</label>
                        <ReactQuill
                            className="quill-editor"
                            theme="snow"
                            value={talkDescription}
                            onChange={setTalkDescription}
                            placeholder="Brief description of the talk..."
                        />
                    </div>
                    <div className="field">
                        <label>Optional Message</label>
                        <ReactQuill
                            className="quill-editor"
                            theme="snow"
                            value={optionalMessage}
                            onChange={setOptionalMessage}
                            placeholder="Any extra notes, reminders, or calls to action..."
                        />
                    </div>
                </>
            );
        }

        if (emailType === EMAIL_TYPES.ANNOUNCEMENT) {
            return (
                <div className="field">
                    <label>Announcement Body</label>
                    <ReactQuill
                        className="quill-editor"
                        theme="snow"
                        value={announcementBody}
                        onChange={setAnnouncementBody}
                        placeholder="Write your announcement here..."
                    />
                </div>
            );
        }

        if (emailType === EMAIL_TYPES.IMAGE) {
            return (
                <>
                    <div className="field">
                        <label>Message Body</label>
                        <ReactQuill
                            className="quill-editor"
                            theme="snow"
                            value={imageBody}
                            onChange={setImageBody}
                            placeholder="Write the message that goes with your image..."
                        />
                    </div>
                    <div className="field">
                        <label>Image URL</label>
                        <input
                            type="text"
                            value={imageUrl}
                            onChange={(e) => setImageUrl(e.target.value)}
                            placeholder="https://example.com/your-image.png"
                        />
                    </div>
                </>
            );
        }

        return null;
    };

    return (
        <>
            <Navbar />
            <div className="email-builder-page">
                <div className="email-builder-layout">
                    <div className="email-builder-form">
                        <h1 className="email-builder-title">Email Builder</h1>
                        <p className="email-builder-subtitle">
                            Generate SOLE-branded HTML emails for meetings, announcements, and
                            image-based updates.
                        </p>

                        <div className="field">
                            <label>Email Type</label>
                            <select
                                value={emailType}
                                onChange={(e) => setEmailType(e.target.value)}
                            >
                                <option value={EMAIL_TYPES.MEETING}>Meeting Email</option>
                                <option value={EMAIL_TYPES.ANNOUNCEMENT}>
                                    Announcement Email
                                </option>
                                <option value={EMAIL_TYPES.IMAGE}>Image Email</option>
                            </select>
                        </div>

                        <div className="field">
                            <label>Subject Line</label>
                            <input
                                type="text"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                placeholder="SOLE Meeting: Why We Need Organized Religion"
                            />
                        </div>

                        {renderTypeSpecificFields()}
                    </div>

                    <div className="email-builder-output">
                        <div className="email-builder-preview">
                            <div className="email-builder-output-header">
                                <h2>Preview</h2>
                                <div className="email-builder-output-actions">
                                    <button type="button" onClick={handleCopyHtml}>
                                        {copied ? "Copied!" : "Copy HTML"}
                                    </button>
                                    <button type="button" onClick={handleCopyFormatted}>
                                        {copiedFormatted ? "Copied!" : "Copy for Gmail/Apple Mail"}
                                    </button>
                                    <button type="button" onClick={handleCopyMailingList}>
                                        {copiedMailingList ? "Copied!" : "Copy Mailing List"}
                                    </button>
                                </div>
                            </div>
                            <iframe
                                title="Email Preview"
                                srcDoc={htmlOutput}
                                key={htmlOutput}
                                style={{
                                    width: "100%",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "8px",
                                    background: "white",
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div
                    ref={formattedRef}
                    style={{
                        position: "absolute",
                        left: "-9999px",
                        top: "-9999px",
                        opacity: 0,
                        pointerEvents: "none",
                    }}
                    dangerouslySetInnerHTML={{ __html: emailInnerHtml }}
                />
            </div>
        </>
    );
};

export default Email;
